import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/programs",
)({
  staticData: { title: "Programs" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/programs/programs.tsx"),
    "Programs",
  ),
})
